import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header Entrega Obra Lista.
 * 
 */

type Props = {
  idsCentroCusto?: number[];
  ddlCentroCusto?: DropDown[];
  status?: number;

  onClearFilters: () => void;
  onIdsCentroCustoChange: (novoIdsCentroCusto: number[] | null) => void;
  onStatusChange: (novoStatus: number | null) => void;
};


export const Header = ({
  idsCentroCusto,
  ddlCentroCusto,
  status,

  onClearFilters,
  onIdsCentroCustoChange,
  onStatusChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const ddlStatus: DropDown[] = [
    { id: 2, title: 'Todos' },
    { id: 0, title: 'Em aberto' },
    { id: 1, title: 'Entregues' },
  ];


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-[40%]">

                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto?.filter(x => idsCentroCusto?.includes(x.id)) ?? []}
                  options={ddlCentroCusto ?? []}
                  getOptionKey={x => x.id}
                  getOptionLabel={x => x.title}
                  onChange={e => onIdsCentroCustoChange(e !== null ? e.map(x => x.id) : null)}
                />
              </div>

              <div className="w-[20%]">
                <DefaultAutocomplete
                  label='Status'
                  value={ddlStatus.find(x => x.id === status) ?? null}
                  options={ddlStatus}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => onStatusChange(x?.id ?? null)} />
              </div>

            </div>



            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}